
import { createWebHistory, createRouter } from "vue-router";
import Home from '../components/App/Home/Home/Home.vue';
export const routes = [
    {
        path: '/',
        redirect: '/home', // Redirigir la raíz a /home
    },
    {
        name: 'home',
        path: '/home',
        component: Home,
        meta: { title: 'Bienvenido', requiresAuth: false },
    },
    {
        name: 'users',
        path: '/users',
        component: () => import(/* webpackChunkName: "UsersV220620261600" */ '../components/Users.vue'),
        meta: { title: 'Admin. Usuarios', requiresAuth: true, roles: ['admin'], permisos: ['users-read'] },
    },
    {
        name: 'register',
        path: '/register',
        component: () => import(/* webpackChunkName: "Register" */ '../pages/Register.vue'),
        meta: { title: 'Nuevo User', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'Ingresa',
        path: '/Ingresa',
        component: () => import(/* webpackChunkName: "LoginV300420261830" */ '../components/Auth/Login.vue'),
        meta: { title: 'Inicia Sesión' },
    },
    {
        name: 'dashboard',
        path: '/dashboard',
        component: () => import(/* webpackChunkName: "DashboardComponentV300420261830" */ '../components/App/Management/Cliente/DashboardComponent.vue'),
        meta: { title: 'Escritorio', requiresAuth: true, roles: ['cliente'] },
    },
    {
        name: 'contacto',
        path: '/Contacto',
        component: () => import(/* webpackChunkName: "ContactoEmpresaV180720262057" */ '../components/navegation/ContactoEmpresa.vue'),
        meta: { title: 'Contacto' }
    },
    {
        name: 'ProdsMX',
        path: '/ProdsMX',
        component: () => import(/* webpackChunkName: "prodmxV180720262057" */ '../components/navegation/prodmx.vue'),
        meta: { title: 'Hechos en México' }
    },
    {
        name: 'OurBrands',
        path: '/OurBrands',
        component: () => import(/* webpackChunkName: "nuestrasmarcasV180720262057" */ '../components/navegation/nuestrasmarcas.vue'),
        meta: { title: 'Nuestras Marcas' }
    },
    {
        name: 'posts',
        path: '/posts',
        component: () => import(/* webpackChunkName: "Posts" */ '../components/Posts.vue'),
        meta: { title: 'Admin. Banners', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'addpost',
        path: '/posts/add',
        component: () => import(/* webpackChunkName: "AddPost" */ '../components/AddPost.vue'),
        meta: { title: 'Crear Banner', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'editpost',
        path: '/posts/edit/:id',
        component: () => import(/* webpackChunkName: "EditPost" */ '../components/EditPost.vue'),
        meta: { title: 'Editar Banner', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'roles',
        path: '/roles',
        component: () => import(/* webpackChunkName: "roles" */ '../Admin/roles/Index.vue'),
        meta: { title: 'Index Roles', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'permisos',
        path: '/permisos',
        component: () => import(/* webpackChunkName: "permisos" */ '../Admin/permissions/index.vue'),
        meta: { title: 'Index Permisos', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'editpermiso',
        path: '/permisos/edit/:id',
        component: () => import(/* webpackChunkName: "editpermiso" */ '../Admin/permissions/Edit.vue'),
        meta: { title: 'Edit Permisos', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'addPermisos',
        path: '/permisos/add',
        component: () => import(/* webpackChunkName: "addPermisos" */ '../Admin/permissions/create.vue'),
        meta: { title: 'Add Permiso', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'addRole',
        path: '/roles/add',
        component: () => import(/* webpackChunkName: "addRole" */ '../Admin/roles/AddRole.vue'),
        meta: { title: 'Add Rol', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'editrole',
        path: '/roles/edit/:id',
        component: () => import(/* webpackChunkName: "editrole" */ '../Admin/roles/EditRole.vue'),
        meta: { title: 'Editar Rol', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'edituser',
        path: '/users/getPermissions/:id',
        component: () => import(/* webpackChunkName: "edituser" */ '../components/EditUser.vue'),
        meta: { title: 'Editar Usuario', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'marcas',
        path: '/marcas',
        component: () => import(/* webpackChunkName: "marcas" */ '../comunidad/marcas.vue'),
        meta: { title: 'Nuestras Marcas' }
    },
    {
        name: 'excel',
        path: '/actualizarprods',
        component: () => import(/* webpackChunkName: "CargaProdsV140820261640" */ '../components/UploadExcel/CargaProds.vue'),
        meta: { title: 'Carga Productos', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'detalleProducto',
        path: '/detalleProducto',
        component: () => import(/* webpackChunkName: "DDPV140820261547" */'../components/App/Sales/DDP/DDP.vue'),
        meta: { title: 'Detalle de Producto' }
    },
    {
        name: 'Listayear',
        path: '/Listayear',
        component: () => import(/* webpackChunkName: "adminprods" */ '../components/Prods/adminprods.vue'),
        meta: { title: 'Admin Producto', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'addmarca',
        path: '/marca/add',
        component: () => import(/* webpackChunkName: "addMarca" */ '../components/Prods/addMarca.vue'),
        meta: { title: 'Agregar Marca', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'ListadoProds',
        path: '/ListaProds',
        component: () => import(/* webpackChunkName: "productosAdmin" */ '../Admin/Productos/Productos.vue'),
        meta: { title: 'Productos' }
    },
    {
        name: 'BusquedaProductos',
        path: '/BusquedaProductos',
        component: () => import(/* webpackChunkName: "BusquedaProductosV140820262030" */'../components/App/Sales/RMB/BusquedaProductos.vue'),
        meta: { title: 'Resultados' },
    },
    {
        name: 'ListadoProductos',
        path: '/ListadoProductos',
        component: () => import(/* webpackChunkName: "ProductCardLineaV140820262030" */'../components/App/Sales/RMB/ProductCardLinea.vue'),
        meta: { title: 'Resultados' }
    },
    {
        name: 'CatalogoListaProductos',
        path: '/catalogo/busqueda/:year/:marca/:modelo/:motor',
        component: () => import(/* webpackChunkName: "catalogoprods" */ '../components/Prods/catalogoprods.vue'),
        meta: { title: 'Busqueda por Catalogo' }
    },
    {
        name: 'listadocotizaciones',
        path: '/listadocotizaciones',
        component: () => import(/* webpackChunkName: "userpedidos" */ '../components/navegation/userpedidos.vue'),
        meta: { title: 'List. Ped. No Auth.', requiresAuth: true, roles: ['cliente'] },
    },
    {
        name: 'listadocotizacionesaut',
        path: '/listadocotizacionesaut',
        component: () => import(/* webpackChunkName: "userpedidos2V220420261700" */ '../components/App/Management/Cliente/Documents/Pedidos/userpedidos2.vue'),
        meta: { title: 'List. Ped. Auth.', requiresAuth: true, roles: ['cliente'] },
    },
    {
        name: 'CartItemsList',
        path: '/CartItemsList',
        component: () => import(/* webpackChunkName: "ItemsCartListV220620261600" */ '../components/App/Sales/Carshop/ItemsCartList.vue'),
        meta: { title: 'Mi carrit', requiresAuth: true, permisos: ['permission_compras'] },
    },
    {
        name: 'admindashboard',
        path: '/AdminDashboard',
        component: () => import(/* webpackChunkName: "dashboardAdminV230920251047" */ '../Admin/dashboardAdmin.vue'),
        meta: { title: 'Dashboard Admin', requiresAuth: true, roles: ['admin'], permisos: ['users-read', 'publicaciones-read'] },
    },
    {
        path: '/detalles-pedido',
        name: 'DetallesPedido',
        component: () => import(/* webpackChunkName: "DetallePedido" */ '../components/navegation/DetallePedido.vue'),
        meta: { title: 'Detalles Pedido', requiresAuth: true },
    },
    {
        path: '/Facturas',
        name: 'Facturas',
        component: () => import(/* webpackChunkName: "EnvoiceListV220420261700" */ '../components/App/Management/Cliente/Documents/Facturas/EnvoiceList.vue'),
        meta: { title: 'Estado Cuenta', requiresAuth: true, roles: ['cliente'] },
    },
    {
        path: '/FacturasConciliacion',
        name: 'Conciliacion',
        component: () => import('../components/App/Management/Cliente/Documents/Facturas/EnvoicesConciliation.vue'),
        meta: { title: 'Conciliación Facturas', requiresAuth: true },
    },
    {
        path: '/DetailsInvoce',
        //component: DetailsInvoce,
        component: () => import(/* webpackChunkName: "DetailsEnvoiceV220420261700" */'../components/App/Management/Cliente/Documents/Facturas/DetailsEnvoice.vue'),
        meta: { title: 'Detalles Factura', requiresAuth: true, roles: ['cliente'] },
    },
    {
        name: 'documentoindexview',
        path: '/documentoindexview',
        component: () => import(/* webpackChunkName: "DocumentosIndex" */ '../components/DocumentosIndex.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'documentocreateview',
        path: '/documentocreateview',
        component: () => import(/* webpackChunkName: "DocumentosCreate" */ '../components/DocumentosCreate.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'documentoeditview',
        path: '/documentoeditview/:id',
        component: () => import(/* webpackChunkName: "DocumentosEdit" */ '../components/DocumentosEdit.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },

    {
        name: 'catalogosview',
        path: '/catalogosview',
        component: () => import(/* webpackChunkName: "Catalogos" */ '../components/Catalogos.vue'),
        meta: { title: 'Pdf Catalogos' }
    },
    {
        name: 'catalogoview',
        path: '/catalogoview/:year?/:categoria?',
        component: () => import(/* webpackChunkName: "CatalogoAvance" */ '../components/viewsCart/CatalogoAvance.vue'),
        meta: { title: 'Busquedas' }
    },
    {
        name: 'contacto',
        path: '/Contacto',
        component: () => import(/* webpackChunkName: "ContactoEmpresa" */ '../components/navegation/ContactoEmpresa.vue'),
        meta: { title: 'Contactanos' }
    },

    {
        name: 'RelMarcaLinea',
        path: '/RelMarcaLinea/:operacion',
        component: () => import(/* webpackChunkName: "RelLinMar" */ '../Admin/Productos/RelLinMar.vue'),
        meta: { title: 'Relaciones Categorias', requiresAuth: true, roles: ['admin'] }
    },
    {
        name: 'UploadFileCar',
        path: '/UploadFileCar',
        component: () => import(/* webpackChunkName: "UploadFileCarV140120261324" */ '../components/viewsCart/UploadFileCar.vue'),
        meta: { title: 'Carga Archivo Cart', requiresAuth: true }
    },
    {
        name: 'DetallePrepedido',
        path: '/DetallePrepedido',
        component: () => import(/* webpackChunkName: "DetallCotV060820261455" */ '../components/navegation/Cotizaciones/DetallCot.vue'),
        meta: { title: 'Aprobación Prepedido', requiresAuth: true }
    },
    {
        name: 'DetallePedidoCreado',
        path: '/DetallePedidoCreado/:sucursal/:folio',
        component: () => import(/* webpackChunkName: "DetallePedidoCreado" */ '../components/navegation/Cotizaciones/DetallePedidoCreado.vue'),
        meta: { title: 'Confirmación Prepedido', requiresAuth: true }
    },
    {
        name: 'DetallePrepedidoAuth',
        path: '/DetallePrepedidoAuth',
        component: () => import(/* webpackChunkName: "DetallePedidoAuthV150920251917" */ '../components/navegation/Cotizaciones/DetallePedidoAuth.vue'),
        meta: { title: 'Confirmación Prepedido', requiresAuth: true }
    },
    {
        name: 'Publicaciones',
        path: '/Publicaciones/:id?',
        component: () => import(/* webpackChunkName: "PublicacionFormV230920251047" */ '../components/Documentos/PublicacionForm.vue'),
        meta: { requiresAuth: true, roles: ['admin'] }
    },
    {
        name: 'ListBolletin',
        path: '/ListBolletin',
        component: () => import(/* webpackChunkName: "ListBolletin2V140820262030" */ '../comunidad/ListBolletin2.vue'),
        meta: { title: 'Boletínes' }
    },
    {
        name: 'EditProds',
        path: '/EditProds/:id',
        component: () => import(/* webpackChunkName: "edit-prods" */ '../Admin/configuraciones/EditProds.vue'),
        meta: { title: 'Editar Producto', requiresAuth: true, roles: ['admin'] }
    },
    {
        name: 'CreateProd',
        path: '/CreateProd',
        component: () => import(/* webpackChunkName: "crear-producto" */ '../Admin/configuraciones/CrateProd.vue'),
        meta: { title: 'Creación Producto', requiresAuth: true, roles: ['admin'] }
    },
    {
        name: 'Productos',
        path: '/Productos',
        component: () => import(/* webpackChunkName: "productos-adminV140820262030" */ '../Admin/configuraciones/viewprods.vue'),
        meta: { requiresAuth: true }
    },
    {
        name: 'ListPublicaciones',
        path: '/ListPublicaciones',
        component: () => import(/* webpackChunkName: "ListBolletinPublicaciones" */ '../comunidad/ListBolletinPublicaciones.vue'),
        meta: { title: 'Index Publicaciónes', requiresAuth: true, roles: ['admin'] }
    },
    {
        name: 'ListPublicacionesEdit',
        path: '/ListPublicacionesEdit',
        component: () => import(/* webpackChunkName: "ListBolletinPublicacionesEdit" */ '../comunidad/ListBolletinPublicacionesEdit.vue'),
        meta: { title: 'Editar Publicación', requiresAuth: true, roles: ['admin'] }
    },
    {
        name: 'ListBlogs',
        path: '/ListBlogs',
        component: () => import(/* webpackChunkName: "ListPublicacionesClientesV180720262057" */ '../comunidad/ListPublicacionesClientes.vue'),
        meta: { title: 'Publicaciónes' }
    },
    {
        name: 'DetallePost',
        path: '/DetallePosts/:id',
        component: () => import(/* webpackChunkName: "DetallPostClientes" */ '../comunidad/DetallPostClientes.vue'),
        meta: { title: 'Detalle Post' }
    },
    {
        name: 'unauthorized',
        path: '/unauthorized',
        component: () => import(/* webpackChunkName: "unauthorized" */ '../Admin/Errores/unauthorized.vue'),
        meta: { title: 'No autorizado' }
    },
    {
        name: 'Correos',
        path: '/Correos',
        component: () => import(/* webpackChunkName: "configuracionescorreo" */ '../Admin/configuraciones/configuracionescorreo.vue'),
        meta: { title: 'Config Correos', requiresAuth: true, roles: ['admin'] }
    },
    {
        name: 'DetailsErrosProds',
        path: '/DetailsErrosProds',
        component: () => import(/* webpackChunkName: "adminerrorsproducto" */ '../Admin/Errores/adminerrorsproducto.vue'),
        meta: { title: 'List. Error Prods.', requiresAuth: true, roles: ['admin'] }
    },
    {
        name: 'DetailsErrosCarts',
        path: '/DetailsErrosCarts',
        component: () => import(/* webpackChunkName: "adminerrorscart" */ '../Admin/Errores/adminerrorscart.vue'),
        meta: { title: 'List. Error Cart', requiresAuth: true, roles: ['admin'] }
    },
    {
        name: 'HerramientasClienteCotizador',
        path: '/HelpCotizador',
        component: () => import(/* webpackChunkName: "HelpCotizadorV220620261600" */ '../HelpUsers/HelpCotizador.vue'),
        meta: { title: 'Cotizador', requiresAuth: true, roles: ['cliente'] }
    },
    {
        name: 'Sync',
        path: '/Sync',
        component: () => import(/* webpackChunkName: "AdminProdsSyncErp" */ '../Admin/Productos/AdminProdsSyncErp.vue'),
        meta: { title: 'Sync. Prods.', requiresAuth: true, roles: ['admin'] }
    },
    {
        name: 'SyncAuth',
        path: '/SyncAuth/:id',
        component: () => import(/* webpackChunkName: "AuthProdsSyncErp" */ '../Admin/Productos/AuthProdsSyncErp.vue'),
        meta: { title: 'Sync. Auth. Prods.', requiresAuth: true, roles: ['admin'] }
    },
    {
        path: '/AdminFichas',
        name: 'AdminFichas',
        component: () => import(/* webpackChunkName: "IndexFichas" */ '../Admin/Fichas/IndexFichas.vue')
    },
    {
        path: '/crearfichas',
        name: 'CrearFicha',
        component: () => import(/* webpackChunkName: "crear-ficha" */ '../Admin/Fichas/CrearFicha.vue')
    },
    {
        path: '/fichas/:id/editar',
        name: 'EditarFicha',
        component: () => import(/* webpackChunkName: "editar-ficha" */ '../Admin/Fichas/EditarFicha.vue'),
        props: true
    },
    {
        name: 'asesoresdashboard',
        path: '/AsesorDashboard',
        component: () => import(/* webpackChunkName: "dashboard-asesores" */ '../asesores/DashboardComponent.vue'),
        meta: { title: 'Dashboard Asesor', requiresAuth: true, roles: ['asesor'] }
    },
    {
        name: 'tmkdashboard',
        path: '/TmkDashboard',
        component: () => import(/* webpackChunkName: "dashboard-tmk" */ '../tmk/DashboardComponent.vue'),
        meta: { title: 'Dashboard Tmk', requiresAuth: true, roles: ['vendedor'] }
    },
    {
        path: '/busquedaAvanzada',
        name: 'BusquedaAvanzada',
        component: () => import(/* webpackChunkName: "resultadosV140820262030" */ '../components/App/Sales/RMB/resultados.vue'),
        meta: { title: 'Resultados' },
        props: route => ({
            year: route.query.year,
            marca: route.query.marca,
            modelo: route.query.modelo,
            motor: route.query.motor,
            linea: route.query.linea,
            idBusqueda: route.query.idBusqueda,
            tipobusqueda: route.query.tipobusqueda,
            activoUsuario: route.query.activoUsuario
        })
    },
    {
        name: 'documentosconsultSat',
        path: '/documentosconsultSat',
        component: () => import(/* webpackChunkName: "DoctosSat" */'../Admin/configuraciones/DoctosSat.vue'),
        meta: { title: 'Admin Docto Sat.', requiresAuth: true, roles: ['admin'] },
    },
    {
        name: 'consultdocumentosSat',
        path: '/consultdocumentosSat',
        component: () => import(/* webpackChunkName: "DetalleDocumentosV071120252058" */'../asesores/Clientes/DetalleDocumentos.vue'),
        meta: { title: 'Consulta Doctos Sat.', requiresAuth: true, roles: ['cliente'] },
    },
    {
        path: '/DetalleDocuments',
        name: 'DocumentosDetalle',
        component: () => import(/* webpackChunkName: "DocumentsElectDetalle" */'../asesores/Clientes/DocumentsElectDetalle.vue'),
        meta: { title: 'Detalle Docto Sat.', requiresAuth: true, roles: ['cliente'] },
    },
    {
        path: '/anunciosadmin',
        name: 'anunciosadmin',
        component: () => import(/* webpackChunkName: "AnuncioPersonalizado" */'../Admin/Publicidad/AnuncioPersonalizado.vue'),
        meta: {
            title: 'Administración de Anuncios', requiresAuth: true, roles: ['admin']
        }
    },
    {
        name: 'indicadores',
        path: '/Indicadores',
        component: () => import(/* webpackChunkName: "indicadoresV230920251047" */'../asesores/indicadores.vue'),
        meta: { title: 'Detalles Ventas', requiresAuth: true, roles: ['admin'] },
    },
    {
        /*analisis clientes */
        path: '/DetalleClientes',
        name: 'DetalleClientes',
        component: () => import(/* webpackChunkName: "DetalleClienteV230920251047" */'../asesores/Clientes/DetalleCliente.vue'),
        meta: { title: 'Comportamiento de Clientes', requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/top-ventas',
        name: 'topventas',
        component: () => import(/* webpackChunkName: "TopVentasV140820262030" */'../components/App/Sales/DDP/visual_assets/TopVentas.vue'),
        meta: { title: 'Top Ventas' },
        props: route => ({
            tipoRanking: route.query.tipoRanking || 'general',
            idLinea: route.query.idLinea || null,
            nombre: route.query.nombre || null
        })
    },

    // Top Ventas por Línea (ya no usamos :id)
    {
        path: '/top-ventas-linea',
        name: 'topventaslinea',
        component: () => import(/* webpackChunkName: "TopVentasV140820262030" */'../components/App/Sales/DDP/visual_assets/TopVentas.vue'),
        meta: { title: 'Top Ventas Línea' },
        props: route => ({
            tipoRanking: route.query.tipoRanking || 'linea',
            idLinea: route.query.idLinea || null,
            nombre: route.query.nombre || null
        })
    },
    {
        path: '/productosdetailsbuy',
        name: 'productosdetailsbuy',
        component: () => import('../components/App/Management/Admin/Marcadores/Indicadores/SalesProduct.vue'),
        meta: { title: 'Top Ventas Línea' }
    },
    {
        path: '/AdminPagos',
        name: 'AdminPagos',
        component: () => import('../components/App/Management/Cliente/Pagos/AdminPagos.vue'),
        meta: {
            title: 'Administración de Pagos',
            requiresAuth: true, roles: ['cliente']
        }
    },
    {
        path: '/PagosAdmin',
        name: 'PagosAdmin',
        component: () => import('../components/App/Management/AdminClient/Pagos/PagosAdmin.vue'),
        //meta: { title: 'Administración Pagos ', requiresAuth: true, roles: ['admin', 'PaymentAdmin', 'asesor', 'vendedor'] },
        meta: { title: 'Administración Pagos ', requiresAuth: true, roles: ['admin', 'PaymentAdmin'] },
    },
    {
        path: '/Busquedaspordiagrama',
        name: 'Busquedaspordiagrama',
        component: () => import('../components/App/Sales/RMB/Busquedaspordiagrama.vue')
    },
    {
        path: '/:catchAll(.*)', // Ruta de captura para cualquier ruta no definida
        redirect: '/' // Redirige a la ruta de inicio (Home)
    }
];



const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // si es navegación con "volver", conserva scroll
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    }
});


router.beforeEach((to, from, next) => {
    const isAuthenticated = window.Laravel.isLoggedin || false;
    const userRoles = window.Laravel.roles || [];
    const userPermisos = window.Laravel.permissions || [];

    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated) {
            // Redirige si no está autenticado
            window.location.href = `${window.location.origin}/Ingresa`;
        } else {
            const requiredRoles = to.meta.roles || [];
            const requiredPermisos = to.meta.permisos || [];

            // Excepción para el rol 'admin', siempre tendrá acceso
            if (userRoles.includes('admin')) {
                next();
                return;
            }
            // 1. Definimos si la ruta requiere alguna restricción
            const requiereRoles = requiredRoles.length > 0;
            const requierePermisos = requiredPermisos.length > 0;

            // 2. Si la ruta no requiere NADA (ni roles ni permisos), es acceso libre
            if (!requiereRoles && !requierePermisos) {
                return next();
            }

            // 3. Si requiere algo, verificamos si el usuario cumple con alguna de las dos
            const tieneRolValido = requiereRoles && requiredRoles.some(role => userRoles.includes(role));
            const tienePermisoValido = requierePermisos && requiredPermisos.every(permiso => userPermisos.includes(permiso));

            // 4. Validación final: Si cumple el rol O cumple el permiso, pasa.
            if (tieneRolValido || tienePermisoValido) {
                next();
            } else {
                // Si la ruta pedía algo y no cumplió nada, a 'unauthorized'
                next({ name: 'unauthorized' });
            }
        }
    } else {
        next();
    }
});
router.afterEach(() => {
    setTimeout(() => {
        const input = document.querySelector('input[aria-label="Search"]');
        if (input) input.focus();
    }, 0);
});
export default router;